// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4fBTkY6vx{height:40px}._3Fe2b8Llx{font-size:14px;line-height:20px;word-wrap:break-word}._4kXYPXzLx{display:flex;align-items:baseline}._4kXYPXzLx ._5cZ0O5Y6x{color:var(--secondary-text);margin-left:20px;font-size:12px}._6RFxdrMgx,._6xy83AJVx{margin-top:40px;margin-bottom:1em;padding:40px}\n", "",{"version":3,"sources":["webpack://client/login/invitations/app-invitation.scss"],"names":[],"mappings":"AAAwmB,YAAM,WAAW,CAAC,YAAiB,cAAc,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,YAAS,YAAY,CAAC,oBAAoB,CAAC,wBAAkB,2BAA2B,CAAC,gBAAgB,CAAC,cAAc,CAAC,wBAAgB,eAAe,CAAC,iBAAiB,CAAC,YAAY","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.logo{height:40px}.invitation-text{font-size:14px;line-height:20px;word-wrap:break-word}.actions{display:flex;align-items:baseline}.actions .decline{color:var(--secondary-text);margin-left:20px;font-size:12px}.success,.alert{margin-top:40px;margin-bottom:1em;padding:40px}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"logo": "_4fBTkY6vx",
	"invitation-text": "_3Fe2b8Llx",
	"invitationText": "_3Fe2b8Llx",
	"actions": "_4kXYPXzLx",
	"decline": "_5cZ0O5Y6x",
	"success": "_6RFxdrMgx",
	"alert": "_6xy83AJVx"
};
export default ___CSS_LOADER_EXPORT___;
